import * as React from "react";

interface ErrorBoundaryProps {
  fallback: React.ReactNode;
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

function logErrorToMyService(error: Error, componentStack: string, ownerStack: string): void {
  // Implement your logging logic here.
  console.error("Logged error:", error, componentStack, ownerStack);
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  // Use getDerivedStateFromError to update state on error
  static getDerivedStateFromError(_: Error): Partial<ErrorBoundaryState> {
    return { hasError: true };
  }

  // Log error details using componentDidCatch
  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // React.captureOwnerStack is not officially part of the public API.
    // Use a type assertion or provide fallback logic.
    const ownerStack = (React as any).captureOwnerStack?.() ?? "No owner stack available";
    logErrorToMyService(error, info.componentStack || "", ownerStack);
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      // Render custom fallback UI
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
